import Immutable from 'immutable';

export interface RawPlacePunch {
  type: string;
  sheetid: string;
  pageid: string;
}

export interface PlacePunchData {
  type: string;
  sheetid: string;
  pageid: string;
}

const defaultValues: PlacePunchData = {
  type: 'PlacePunch',
  sheetid: '',
  pageid: '',
};

export const PlacePunchFactory = Immutable.Record(defaultValues, 'PlacePunch');

export class PlacePunch extends PlacePunchFactory {
  static deserialize(rawPlacePunch: RawPlacePunch): PlacePunch {
    return new PlacePunch({
      ...rawPlacePunch,
    });
  }

  serialize(): RawPlacePunch {
    return this.toObject();
  }
}
